import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import {ErrorMessage, Field} from "formik";
import {useEffect, useRef, useState} from "react";
import OtpInput from "react-otp-input";
import MDButton from "../../../../../components/MDButton";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import {Tooltip} from "@material-ui/core";
import {useSendOtpMutation} from "../../../../../store/api/validation";
import {notificationActions} from "../../../../../store/notification/notification-slice";
import {useDispatch} from "react-redux";
import Countdown from 'react-countdown';
import ReCAPTCHA from "react-google-recaptcha";

export const OtpEmailVerification = ({formData, setNextValid}) => {
    const {formField, values, errors, touched, setFieldValue} = formData;
    const {email_otp} = formField;
    const {
        email_otp: emailOtpV,
    } = values;
    const [sendOtp] = useSendOtpMutation();
    const dispatch = useDispatch();

    const resendOtp = async () => {
        dispatch(notificationActions.showLoading(true));

        const payload = await sendOtp({
            destination: values.email,
            email: values.email
        });

        if (payload?.data?.success) {
            dispatch(notificationActions.showMessage({
                message: `EMail: ${payload?.data?.message}`,
                variant: "success"
            }));
        }
        if (payload?.error?.data) {
            dispatch(notificationActions.showMessage({
                message: `Email: ${payload?.error?.data?.detail}`,
                variant: "error"
            }));
        }
        dispatch(notificationActions.showLoading(false));
    }
    useEffect(() => {
        if (emailOtpV?.length === 5) {
            setNextValid(true);
        } else {
            setNextValid(false);
        }
    }, [emailOtpV]);

    const recaptchaRef = useRef();
    const [showCaptcha, setShowCaptcha] = useState(false);

    return (
        <MDBox>
            <MDTypography variant="h5">E-Mail Verification for {values.email}</MDTypography>
            <MDBox mt={3}>
                <Grid container spacing={3}>
                    <Grid item xs={8} sm={8}>
                        <MDBox mb={1.5}>
                            <Field
                                onChange={(newValue) => {
                                    setFieldValue("email_otp", newValue);
                                }}
                                fullWidth
                                numInputs={5}
                                separator={<span>-</span>}
                                isInputNum={true}
                                value={emailOtpV}
                                name={email_otp.name} as={OtpInput} variant="standard" label={email_otp.label}/>

                            <MDBox mt={0.75}>
                                <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
                                    <ErrorMessage name={email_otp.name}/>
                                </MDTypography>
                            </MDBox>
                        </MDBox>

                    </Grid>
                    <Grid item xs={4} sm={4}>
                        <Tooltip title="Resend verification Email" placeholder="bottom">
                            <IconButton size="small" aria-label="close" color="inherit" onClick={() => setShowCaptcha(true)}>
                                <Icon fontSize="small">send</Icon>
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    {
                        showCaptcha && (<>
                            <MDTypography component="div" variant="caption" color="success" fontWeight="regular">
                                to send verification code, please confirm...
                            </MDTypography>
                            <ReCAPTCHA
                                ref={recaptchaRef}
                                style={{display: "inline-block"}}
                                sitekey="6LdZkOMiAAAAAF-8GfAqn60jZ5mwsGpv6c8vncob"
                                onChange={(value) => {
                                    setFieldValue("recaptcha", value);
                                    if (value) {
                                        resendOtp()
                                    }
                                }}
                                asyncScriptOnLoad={() => setFieldValue("recaptcha", "")}
                            />
                        </>)
                    }
                </Grid>
            </MDBox>
        </MDBox>
    )
}